import { render, staticRenderFns } from "./AddParticipantSignature.vue?vue&type=template&id=46022d5e&scoped=true"
import script from "./AddParticipantSignature.vue?vue&type=script&lang=js"
export * from "./AddParticipantSignature.vue?vue&type=script&lang=js"
import style0 from "./AddParticipantSignature.vue?vue&type=style&index=0&id=46022d5e&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46022d5e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('46022d5e')) {
      api.createRecord('46022d5e', component.options)
    } else {
      api.reload('46022d5e', component.options)
    }
    module.hot.accept("./AddParticipantSignature.vue?vue&type=template&id=46022d5e&scoped=true", function () {
      api.rerender('46022d5e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/infra/announcements/AddLetter/components/AddParticipantSignature.vue"
export default component.exports